define('controllers/consoleApi/credentialsMain.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('CredentialsMain', ['$q', '$scope', '$state', '$rootScope', '$stateParams', 'projectManageService', 'OpenApp', 'ngDialog', 'auiDialog','biAnalyticService',
        function ($q, $scope, $state, $rootScope, $stateParams, projectManageService, OpenApp, ngDialog, auiDialog,biAnalyticService) {
            var Model = $scope.Model = {
                forumDiversionConf: sysParamCfg.forumDiversionConf,
                projectKey: $stateParams.projectKey,
                apiKeySys: {},
                defaultProductTypeFilterMap: {}
            }
            $scope.apiLimitShow = {0: '无', 1: '有'};
            $scope.createApiKey = createApiKey;
            $scope.editApiKey = editApiKey;
            $scope.editSAK = editSAK;
            $scope.delSAK = delSAK;
            $scope.delClient = delClient;
            $scope.editOauth = editOauth;
            $scope.handleJsonFile = handleJsonFile;
            $scope.getOauthClientApiList = getOauthClientApiList;
            $scope.editOauthClient = editOauthClient;
            mainCons.oauthConstant.productTypes.forEach(
                function (t) {
                    Model.defaultProductTypeFilterMap[t.prodType] = t;
                }
            );

            init();

            function init() {
                //如果是从左侧菜单进来的，需要查询CP名下的项目，
                // 如果CP项目为空，跳转到myApi页面创建项目；如果CP项目不为空，默认选择第一个项目展示凭证
                projectManageService.getProjectList().then(function (resp) {
                    if (resp && resp.resultCode == '0') {
                        if (resp && resp.projectInfoList && resp.projectInfoList.length > 0) {
                            var projectInfoList = resp.projectInfoList;
                            if (Model.projectKey != "0") {
                                biAnalyticService.trackPageView("APIConsole - 凭证页面", 'DPRM5062');
                                projectManageService.getProjectInfo({projectKey: Model.projectKey}).then(function (data) {
                                    if (data && data.projectInfo) {
                                        Model.myProject = data.projectInfo;
                                        projectManageService.setProjectKey(Model.myProject.projectKey);
                                        initKey();
                                        return;
                                    }
                                });
                            } else {
                                if (projectManageService.getProjectKey() != '0') {
                                    $state.go($state.current.name, {projectKey: projectManageService.getProjectKey()}, {reload: true});
                                } else {
                                    Model.myProject = projectInfoList[0];
                                    projectManageService.setProjectKey(Model.myProject.projectKey);
                                    Model.projectKey = Model.myProject.projectKey;
                                    $state.go($state.current.name, {projectKey: Model.projectKey}, {reload: true});
                                }
                            }
                        } else {
                            $state.go('myProject', {reload: true});
                        }
                    } else {
                        $state.go('myProject', {reload: true});
                    }
                }).catch(function () {
                    $state.go('myProject', {reload: true});
                });
            }

            //加载 Key列表
            function initKey() {
                projectManageService.getProjectCredentialList(Model.myProject.projectID).then(function (resp) {
                    if (resp && resp.resultCode == "0") {
                        Model.apiKeyList = [];
                        Model.oauthClientInfoList = [];
                        Model.subAccountInfoList = [];
                        Model.publicKeyList = [];
                        Model.limitOauthClientInfoList = [];
                        Model.hasKeyInfo = false;
                        if (resp.apiKeyInfoList && resp.apiKeyInfoList.length > 0) {
                            Model.hasKeyInfo = true;
                            Model.apiKeyList = resp.apiKeyInfoList;
                            //存储下apiKeyName，方便下次生成
                            angular.forEach(Model.apiKeyList, function (apiKey) {
                                Model.apiKeySys[apiKey.apiKeyName] = true;
                                if(apiKey.apiTypeLimit ==1 || apiKey.clientTypeLimit !=1){
                                    apiKey.limit= 1;
                                }else{
                                    apiKey.limit= 0;
                                }
                            });
                        }
                        if (resp.oauthClientInfoList && resp.oauthClientInfoList.length > 0) {
                            Model.hasKeyInfo = true;
                            Model.oauthClientInfoList = resp.oauthClientInfoList;
                            //Oauth凭证，对于产品类型是否可以编辑有配置，不允许编辑的不展示 编辑 按钮
                            angular.forEach(Model.oauthClientInfoList, function (row) {
                                var prodType = angular.copy(row.prodType);
                                if (row.prodType == '19') {
                                    prodType = prodType + '-' + row.freeInstallType;
                                }
                                row.authChange = (Model.defaultProductTypeFilterMap[prodType] && Model.defaultProductTypeFilterMap[prodType].authChange) || false;
                            });

                        }

                        if (resp.subAccountInfoList && resp.subAccountInfoList.length > 0) {
                            Model.subAccountInfoList = resp.subAccountInfoList;
                            Model.publicKeyList = [];
                            Model.subAccountInfoList.forEach(function (row) {
                                if (row.publicKeyList && row.publicKeyList.length > 0) {
                                    row.publicKeyList.forEach(function (serKey) {
                                        row.serviceKeyInfo = {};
                                        row.serviceKeyInfo = angular.copy(serKey);
                                        Model.publicKeyList.push(angular.copy(row));
                                    })
                                }
                            });
                            if(Model.publicKeyList.length>0){
                                Model.hasKeyInfo = true;
                            }
                        }
                        if (resp.limitOauthClientInfoList && resp.limitOauthClientInfoList.length > 0) {
                            Model.hasKeyInfo = true;
                            Model.limitOauthClientInfoList = resp.limitOauthClientInfoList;
                            //Oauth凭证，对于产品类型是否可以编辑有配置，不允许编辑的不展示 编辑 按钮
                            angular.forEach(Model.limitOauthClientInfoList, function (row) {
                                var prodType = angular.copy(row.prodType);
                                if (row.prodType == '19') {
                                    prodType = prodType + '-' + row.freeInstallType;
                                }
                                row.authChange =  (Model.defaultProductTypeFilterMap[prodType] && Model.defaultProductTypeFilterMap[prodType].authChange) || false;
                            });
                        }

                    }

                });
            }


            //创建ApiKey
            function createApiKey() {
                var defer = $q.defer();
                //apiKeyName名称生成规则是 apiKey+i，i是递增自然数。且生成的apiKeyName不存在
                var i = 0;
                do {
                    i++;
                }
                while (Model.apiKeySys['apiKey' + i]);
                var apiKeyName = 'apiKey' + i;

                projectManageService.addApiKey(Model.myProject.projectID, apiKeyName).then(function (resp) {
                    if (resp && resp.resultCode == "0") {
                        initKey();
                        showApiKeyDialog(resp.clientID, resp.apiKey).then(function () {
                            defer.resolve();
                        });
                    } else {
                        defer.reject();
                    }
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //编辑apiKey
            function editApiKey(row) {
                $state.go('apiKey', {
                    projectKey: Model.myProject.projectKey,
                    projectID: Model.myProject.projectID,
                    clientID: row.clientID
                }, {reload: true});
            }

            //删除密钥 客户端ID
            function delClient(clientID,type) {
                var defer = $q.defer();
                var tip = (type ==1?"确定删除此密钥吗？":type ==2?"确定删除此客户端ID吗？":"确定删除此应用级客户端ID吗？");
                var tipmesg = (type ==1?"删除此密钥，会导致此密钥关联的API权限和资源都被删除，无法继续正常使用。":type ==2?"删除此客户端ID，会导致此客户端ID关联的API权限和资源都被删除，无法继续正常使用。":"删除此应用级客户端ID，会导致此应用级客户端ID关联的API权限和资源都被删除，无法继续正常使用。");
                //删除XXX，会导致XXX关联的API权限和资源都被删除，无法继续正常使用。
                auiDialog.confirm(tip,tipmesg, function () {
                    projectManageService.delClient(clientID,type).then(function (resp) {
                        if (resp && resp.resultCode == 0) {
                            auiDialog.success('删除成功');
                            initKey();
                        }
                        defer.resolve();
                    }).catch(function () {
                        defer.reject();
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //展示apiKey弹框页面
            function showApiKeyDialog(clientID, apiKey) {
                var defer = $q.defer();
                var handle = ngDialog.open({
                    template: 'pages/consoleApi/apiKey/apiKey.add.html',
                    className: '',
                    controller: ['$scope', function ($scope) {
                        $scope.clientID = clientID;
                        $scope.apiKey = apiKey;
                        $scope.projectID = Model.myProject.projectID;

                        $scope.limitApi = function () {
                            $state.go('apiKey', {
                                projectKey: Model.myProject.projectKey,
                                projectID: Model.myProject.projectID,
                                clientID: $scope.clientID
                            }, {reload: true});
                            handle.close();
                            defer.resolve();
                        }
                        $scope.cancel = function () {
                            handle.close();
                            defer.resolve();
                        }
                    }]
                });
                return defer.promise;
            }

            //编辑serviceAccoutKey
            function editSAK(row) {
                $state.go('addServiceAcccountKeys', {
                    projectKey: Model.projectKey,
                    clientID: row.clientID,
                    publicKeyID: row.serviceKeyInfo.publicKeyID
                }, {reload: true});
            }

            function delSAK(row) {
                var defer = $q.defer();
                auiDialog.confirm("确定删除此服务帐号密钥吗？", "删除此服务帐号密钥，会导致此服务帐号密钥关联的API权限和资源都被删除，无法继续正常使用。",function () {
                    projectManageService.delSAK(row.serviceKeyInfo.publicKeyID).then(function (resp) {
                        if (resp && resp.resultCode == 0) {
                            auiDialog.success('删除成功',function () {
                                init();
                            });
                        }
                        defer.resolve();
                    }).catch(function () {
                        defer.reject();
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //编辑oauth
            function editOauth(row) {
                $state.go('oauth', {
                    projectKey: Model.projectKey,
                    projectID: row.projectID,
                    clientID: row.clientID
                }, {reload: true});
            }
            //编辑oauthClient
            function editOauthClient(row){
                $state.go('oauthClient', {
                    type:4,
                    projectKey: Model.projectKey,
                    projectID: row.projectID,
                    clientID: row.clientID
                }, {reload: true});
            }

            //下载oauth JSON文件
            function handleJsonFile(row) {
                var defer = $q.defer();
                if (row.prodType == 22) return;
                var text = {
                    "installed": {
                        "client_id": row.clientID,
                        "project_id": Model.myProject.projectKey,
                        "auth_uri": sysUrlCfg.apiConsole.auth_uri,
                        "token_uri": sysUrlCfg.apiConsole.token_uri,
                        "auth_provider_cert_uri": sysUrlCfg.apiConsole.auth_provider_cert_uri,
                        "redirect_uris": []
                    }
                }
                if (row.prodType == 7) {
                    text = {
                        "web": {
                            "client_id": row.clientID,
                            "project_id":Model.myProject.projectKey,
                            "auth_uri": sysUrlCfg.apiConsole.auth_uri,
                            "token_uri": sysUrlCfg.apiConsole.token_uri,
                            "auth_provider_cert_uri": sysUrlCfg.apiConsole.auth_provider_cert_uri,
                            "client_secret": row.appSecret
                        }
                    }
                }


                if (row.oauthClientAttr && row.oauthClientAttr.appAttrs && row.prodType != 7) {
                    var appAttrs = JSON.parse(row.oauthClientAttr.appAttrs);
                    if (appAttrs.oauthRedirectUri) {
                        text.installed.redirect_uris.push(appAttrs.oauthRedirectUri);
                    }
                }

                download("client_secret_" + row.clientID + ".json", text);
                auiDialog.success('下载成功', "client_secret_"+ row.clientID + ".json" + '，请妥善保存。', function () {
                    defer.resolve();
                });
                return defer.promise;

            }

            function download(filename, data) {
                if (typeof data === 'object') {
                    data = JSON.stringify(data, undefined, 4)
                }
                var blob = new Blob([data], {type: 'text/json'});
                var element = document.createElement('a') || document.body.createElement('a');
                element.setAttribute('href', window.URL.createObjectURL(blob));
                element.setAttribute('download', filename);
                if (navigator.msSaveBlob) {
                    return navigator.msSaveBlob(blob, filename);
                }
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
            
            function getOauthClientApiList(row) {
                $state.go('oauthClientApiList', {
                    projectID: row.projectID,
                    clientID: row.clientID
                }, {reload: true});
            }
        }
    ]);
});

